import React, { useState } from 'react';
import { NextSeo } from 'next-seo';
import Layout from '~/components/Layouts/LayoutBasic/LayoutBasic';
// import Breadcrumb from '~/components/BreadcrumbNav/BreadcrumbNav';

import css from '~/styles/about/about.less';

const moduleIcon1 = require('~/static/about/module_1.png');
const moduleIcon2 = require('~/static/about/module_2.png');
const moduleIcon3 = require('~/static/about/module_3.png');
const logoForMatrix = require('~/static/about/logo_for_matrix.png');
const logoForShunwei = require('~/static/about/logo_for_shunwei.png');

const AboutUs = () => {
  const [infoList] = useState([
    '新得宝贝是中国新家庭的服务消费决策和交易平台，于2016年在北京创立。',
    '成立之初便聚焦孕产阶段的各类重决策服务，致力于解决服务消费中的信息不对称问题。如今已从私立医院、月子会所、月嫂、产后康复、摄影，拓展到亲子、早教、保险、实物等多个品类，全面服务新家庭的重要消费决策。',
  ]);

  const [moduleList] = useState([
    {
      icon: moduleIcon1,
      title: '使命',
      desc: '减少错过的遗憾',
    },
    {
      icon: moduleIcon2,
      title: '愿景',
      desc: '成为最受信赖的服务\n消费决策平台',
    },
    {
      icon: moduleIcon3,
      title: '价值观',
      desc: '正直、关怀\n坦诚、迭代',
    },
  ]);

  return (
    <Layout>
      <NextSeo
        title="关于我们 - 新得宝贝"
        description="母婴服务放心选"
        additionalMetaTags={[
          {
            name: 'keywords',
            content: '新得宝贝,MUA孕育守护',
          },
        ]}
      />
      {/* <Breadcrumb title="关于我们" /> */}
      <div className={css.main}>
        <div className={css.sticky}>
          <div className={css.left}>
            <p className={css.pageTitle}>关于我们</p>
          </div>
        </div>

        <div className={css.section}>
          <h3 className={css.title}>我们是谁</h3>
          <ul className={css.introduction}>
            {infoList.map((item, index) => {
              return (
                // eslint-disable-next-line react/no-array-index-key
                <li key={index.toString()} className={css.introductionItem}>
                  {item}
                </li>
              );
            })}
          </ul>
          <ul className={css.module}>
            {moduleList.map((item, index) => {
              return (
                // eslint-disable-next-line react/no-array-index-key
                <li key={index.toString()} className={css.moduleItem}>
                  <img
                    src={item.icon}
                    alt="moduleIcon"
                    className={css.moduleIcon}
                  />
                  <p className={css.moduleTitle}>{item.title}</p>
                  <p className={css.moduleDesc}>{item.desc}</p>
                </li>
              );
            })}
          </ul>

          <h3 className={css.title} style={{ marginBottom: '32px' }}>
            投资方
          </h3>
          <ul className={css.investor}>
            <li className={`${css.investorItem} ${css.matrix}`}>
              <div
                className={css.investorLogo}
                style={{ backgroundImage: `url(${logoForMatrix})` }}
              >
                {' '}
              </div>
              <p className={css.investorName}>经纬中国</p>
            </li>
            <li className={`${css.investorItem} ${css.shunwei}`}>
              <div
                className={css.investorLogo}
                style={{ backgroundImage: `url(${logoForShunwei})` }}
              >
                {' '}
              </div>
              <p className={css.investorName}>顺为资本</p>
            </li>
          </ul>
        </div>
      </div>
    </Layout>
  );
};

AboutUs.getInitialProps = async ({ pathname, query, dvaStore }) => {
  // dispatch effects to fetch data here
  return {
    pathname,
    query,
    dvaStore,
  };
};

export default AboutUs;
